
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AccountGroupDialog extends Serenity.EntityDialog<AccountGroupRow, any> {
        protected getFormKey() { return AccountGroupForm.formKey; }
        protected getIdProperty() { return AccountGroupRow.idProperty; }
        protected getLocalTextPrefix() { return AccountGroupRow.localTextPrefix; }
        protected getNameProperty() { return AccountGroupRow.nameProperty; }
        protected getService() { return AccountGroupService.baseUrl; }
        protected getDeletePermission() { return AccountGroupRow.deletePermission; }
        protected getInsertPermission() { return AccountGroupRow.insertPermission; }
        protected getUpdatePermission() { return AccountGroupRow.updatePermission; }

        protected form = new AccountGroupForm(this.idPrefix);
        constructor() {
            super();
            this.form.GroupUnder.changeSelect2(e => {
                AccountGroupService.Retrieve({ EntityId: parseInt(this.form.GroupUnder.value) }
                    , response => {
                        this.form.Nature.value = response.Entity.Nature;
                    },
                    { async: false });
                //this.form.Nature.value = AccountGroup.getLookup().itemById[this.form.GroupUnder.value].Nature;
            });
            this.form.AccountGroupName.element.css({
                "text-align": "right"
            });
        }
        

    }
}